export default __webpack_public_path__ + "static/media/orange-checkmark-handv.dd4075a6.svg";